import { Breadcrumbs, Typography, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { usePrincipalComercialViewModel } from "../../viewModels/principal_comercial_view_model";
import { Check, DoNotDisturb, Money, Warning } from "@mui/icons-material";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import StatCard from "../../../../../common/components/statCard";
import PrincipaisDocGrid from "../../../../../common/components/principaisDocGrid";

/**
 * PrincipalComercial
 */

export const PrincipalComercial = () => {
  const viewModel = usePrincipalComercialViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
            * Page
            */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Comercial
          </Link>
          <Typography className="text-primary-green">
            Principal Comercial
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Principal Comercial</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                {
                  viewModel.dashboardComercialInformation !== null && (
                    <div className="w-full flex flex-col gap-4 mb-8">
                      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                        <StatCard
                          title='Clientes Cadastrados'
                          value={viewModel.dashboardComercialInformation.clientesCadastrados}
                          icon={Money}
                          colorClass={{
                            bg: 'bg-indigo-500',
                            text: 'text-white',
                            bgHover: 'bg-indigo-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('clientesCadastrados')}
                        />

                        <StatCard
                          title='Processos Em Análise'
                          value={viewModel.dashboardComercialInformation.processosAnalise}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-zinc-500',
                            text: 'text-white',
                            bgHover: 'bg-zinc-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosEmAnalise')}
                        />

                        <StatCard
                          title='Processos Descartados'
                          value={viewModel.dashboardComercialInformation.processosDescartados}
                          icon={DoNotDisturb}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosDescartados')}
                        />

                        <StatCard
                          title='Processos Participados'
                          value={viewModel.dashboardComercialInformation.processosParticipados}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosParticipados')}
                        />

                        <StatCard
                          title='Processos Participados Ganhos'
                          value={viewModel.dashboardComercialInformation.processosParticipadosGanhos}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosParticipadosGanhos')}
                        />

                        <StatCard
                          title='Processos Participados Perdidos'
                          value={viewModel.dashboardComercialInformation.processosParticipadosPerdidos}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosParticipadosPerdidos')}
                        />

                        <StatCard
                          title='Processos Participados Inabilitados'
                          value={viewModel.dashboardComercialInformation.processosParticipadosInabilitados}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-zinc-500',
                            text: 'text-white',
                            bgHover: 'bg-zinc-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosParticipadosInabilitados')}
                        />

                        <StatCard
                          title='Processos Participados Outros'
                          value={viewModel.dashboardComercialInformation.processosParticipadosOutros}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('processosParticipadosOutros')}
                        />
                      </div>

                      <PrincipaisDocGrid
                        loading={viewModel.loading}
                        rows={viewModel.docLista}
                        totalItems={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onPageChange={(p) => viewModel.handlePageChange(p)}
                        onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
                        onActionExportar={(IdArquivoModulo, NomeArquivo) =>
                          viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)
                        }
                      />
                    </div>
                  )
                }
              </>
            )
        }
      </div>
    </>
  );
}